import { render, staticRenderFns } from "./rights-agreement.vue?vue&type=template&id=d436bd2e&scoped=true"
import script from "./rights-agreement.vue?vue&type=script&lang=ts"
export * from "./rights-agreement.vue?vue&type=script&lang=ts"
import style0 from "./rights-agreement.vue?vue&type=style&index=0&id=d436bd2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d436bd2e",
  null
  
)

export default component.exports